import { useEffect, useState } from "react";
import { Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { getInstagramFeed } from "../lib/api";
import { SOCIAL } from "../data/site";

export const InstagramFeed = () => {
  const [media, setMedia] = useState([]);

  useEffect(() => {
    getInstagramFeed(8).then((d) => setMedia(d.media || [])).catch(() => setMedia([]));
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-6 py-28 lg:px-10" data-testid="instagram-feed">
      <Reveal className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <p className="overline text-sand-700">Follow the journey</p>
          <h2 className="mt-6 font-display text-5xl text-sand-100 md:text-7xl">@desertvibemedia</h2>
        </div>
        <div className="flex gap-4">
          <a href={SOCIAL.instagram} target="_blank" rel="noopener noreferrer" className="btn-desert" data-testid="ig-follow">
            <Instagram size={16} /> Instagram
          </a>
          <a href={SOCIAL.facebook} target="_blank" rel="noopener noreferrer" className="btn-desert" data-testid="fb-follow">
            <Facebook size={16} /> Facebook
          </a>
        </div>
      </Reveal>

      {media.length > 0 ? (
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
          {media.map((m, i) => (
            <a
              key={m.id || i}
              href={m.permalink || SOCIAL.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block aspect-square overflow-hidden"
              data-testid={`ig-post-${i}`}
            >
              <img src={m.media_url} alt={m.caption ? m.caption.slice(0, 80) : "Instagram post"} loading="lazy" className="h-full w-full object-cover grayscale-[20%] transition-all duration-500 group-hover:scale-105 group-hover:grayscale-0" />
              <div className="absolute inset-0 flex items-center justify-center bg-[#0D0B0A]/40 opacity-0 transition-opacity duration-400 group-hover:opacity-100">
                <Instagram size={26} className="text-sand-100" />
              </div>
            </a>
          ))}
        </div>
      ) : (
        <Reveal>
          <a
            href={SOCIAL.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-start justify-between gap-8 border border-border bg-surface p-10 transition-colors duration-500 hover:bg-[#1d1815] md:flex-row md:items-center lg:p-14"
            data-testid="ig-fallback"
          >
            <div className="flex items-center gap-6">
              <span className="flex h-16 w-16 items-center justify-center border border-sand-700 text-sand-700">
                <Instagram size={28} />
              </span>
              <div>
                <p className="font-display text-3xl text-sand-100">See our latest work on Instagram</p>
                <p className="mt-2 font-body font-light text-sand-400">Behind-the-scenes, reels, and desert stories — updated often.</p>
              </div>
            </div>
            <span className="overline flex items-center gap-2 text-sand-700 transition-transform duration-300 group-hover:translate-x-1">
              @desertvibemedia <ArrowUpRight size={16} />
            </span>
          </a>
        </Reveal>
      )}
    </section>
  );
};

export default InstagramFeed;
